import { Refund } from 'store/api/refund';
import { EventCheckout } from 'store/api/event';
import { formatPrice, joinStrings } from 'utils/helpers';

export const getRefundFields = (value: Refund, data: EventCheckout) => {
  const result = [
    {
      title: 'Amount',
      value: formatPrice(
        value?.refundPayments?.reduce(
          (acc, curr) => acc + Number(curr.amount),
          0
        )
      ),
    },
    {
      title: 'Total Refund Amount',
      value: formatPrice(value?.totalRefundPayments),
    },
    {
      title: 'Total Processing Fee Amount',
      value: formatPrice(value?.totalRefundProcessingFee),
    },
    {
      title: 'Total Free Shipping Amount',
      value: formatPrice(value?.totalRefundFreeShipping),
    },
  ];

  if (value?.refundPayments?.some((payment) => payment.type === 'credit')) {
    const last4Info = value.refundPayments?.map((payment) => {
      const paymentLast4 = data?.isManualCreditPaymentEnabled
        ? joinStrings(
            data?.paymentMethods?.map((method) => method.last4CC) || [],
            ', '
          )
        : payment?.payment?.last4;

      return `**** ${paymentLast4} (${formatPrice(payment.totalAmount)})`;
    });

    result.push({
      title: 'Credit Card',
      value: joinStrings(last4Info || [], ', '),
    });
  }

  const tipAmount = value?.refundPayments?.reduce(
    (acc, curr) => acc + (Number(curr.tip) || 0),
    0
  );

  if (tipAmount) {
    result.splice(2, 0, {
      title: 'Tip',
      value: formatPrice(tipAmount),
    });
  }

  if (value?.storage?.name) {
    result.splice(1, 0, {
      value: value.storage.name,
      title: 'Return Storage Name',
    });
  }

  return result;
};
